import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';

import { OnboardingStyle } from '../../public/onboarding/onboarding-style';
import usePushDataLayerEvent from '../../../utils/google-analytics.util';
import useManageStorage from '../../../hooks/useManageStorage/useManageStorage';
import { AuthHeader, ContentLayout } from '../../../global-styles/layout';
import { BodyText, Heading2Text } from '../../../components/typography/typography';
import { icons } from '../../../assets/icons/icons';
import { IAssistanceResume } from '../../../api/assistance/assistance.types';
import { getMyAssistances } from '../../../api/assistance/assistance';
import AssistanceCard from './components/AssistanceCard';
import { AssistancesParams } from './asssistances-types';
import { AssistancesStyles } from './assistances-style';

const Assistances = () => {
  const { t } = useTranslation(['common', 'completed']);
  const { file, intervention } = useParams<AssistancesParams>();
  const navigate = useNavigate();
  const { writeToStorage } = useManageStorage();
  const { pushDataLayerEvent } = usePushDataLayerEvent();

  const handleReturn = () => {
    navigate(`/completed/${file}/${intervention}`);
  };

  const [myAssistances, setMyAssistances] = useState<IAssistanceResume[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMyAssistances = async () => {
      if (file) {
        const data = await getMyAssistances(file);
        setMyAssistances([...data].sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime()));
      }
      setLoading(false);
    };

    fetchMyAssistances();
  }, [file]);

  const handleDoSurvey = async (assistance: IAssistanceResume) => {
    pushDataLayerEvent('empezar_encuesta', null, 'finalizar-servicio');
    await writeToStorage('surveyFromCompleted', false);
    navigate(`/survey/${assistance.expediente}/${assistance.intervencion}`);
  };

  return (
    <ContentLayout>
      <AssistancesStyles>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title assistances-title">
                <IconButton className="assistances-title__back" aria-label="back" onClick={handleReturn}>
                  <img src={icons.arrowLeftIcon} alt="" />
                </IconButton>
                <Heading2Text as="h1" weight={600}>
                  {t('completed:assistances:title')}
                </Heading2Text>
              </div>
              <div className="assistances-header-divider">
                <BodyText className="assistances-subtitle">{t('completed:assistances:subtitle')}</BodyText>
              </div>
            </AuthHeader>
            {myAssistances.length > 0 ? (
              <ul className="assistances-list">
                {myAssistances.map((assistance, index) => (
                  <li key={`${assistance.expediente}-${index}`}>
                    <AssistanceCard assistance={assistance} onDoSurvey={handleDoSurvey} />
                  </li>
                ))}
              </ul>
            ) : (
              !loading && <BodyText className="assistances-empty">{t('completed:assistances.empty')}</BodyText>
            )}
          </div>
        </OnboardingStyle>
      </AssistancesStyles>
    </ContentLayout>
  );
};

export default Assistances;
